<template>
  <article class="auction_info">
    <swiper-info
      :images="imagesList"
      :car-info="basiceInfoData"
      @click-swiper="clickSwiper">
    </swiper-info>
    <images-previewer :list="imagesList" ref="previewer" :options="options" :w='600' :h='400'></images-previewer>
    <auction-info :auction="auctionInfo" :frozenAmount="frozenAmount" :minimumPrice="minimumPrice" :reservePrice="reservePrice"></auction-info>
    <store-info :store="store"></store-info>
    <car-info-item
      title="重要信息"
      :title-list="importInfo"
      :data-list="procedureInfoData">
    </car-info-item>
    <car-info-item
      title="基本信息"
      :title-list="basiceInfo"
      :data-list="basiceInfoData">
    </car-info-item>
    <car-info-item
      title="手续信息"
      :title-list="procedureInfo"
      :data-list="procedureInfoData">
    </car-info-item>
    <group class="car_info_item">
      <cell title="查看详细配置信息（精真估）" :link="`/check/configReport/${this.id}/auction`"></cell>
      <cell title="查看质检报告" :link="`/check/inspectionsReport/${this.id}/auction`"></cell>
      <cell title="查看历史车况（查博士）" v-if="basiceInfoData.is_reported" :link="goConditionReport()"></cell>
    </group>
  </article>
</template>
<script>
import {
  Group,
  Cell
  // Previewer
} from '@lx-frontend/cvux'
import ImagesPreviewer from '@lx-frontend/images-previewer'
import SwiperInfo from '../components/SwiperInfo'
import AuctionInfo from '../components/AuctionInfo'
import StoreInfo from '../components/StoreInfo'
import CarInfoItem from '../components/CarInfoItem'
export default {
  components: {
    Group,
    Cell,
    // Previewer,
    ImagesPreviewer,
    SwiperInfo,
    AuctionInfo,
    StoreInfo,
    CarInfoItem
  },
  data() {
    return {
      options: {
        getThumbBoundsFn (index) {
          let isServer = typeof window === 'undefined'
          if (isServer) return
          // find thumbnail element
          let thumbnail = document.querySelectorAll('.vux-img')[index]
          // get window scroll Y
          let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
          // optionally get horizontal scroll
          // get position of element relative to viewport
          let rect = thumbnail.getBoundingClientRect()
          // w = width
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
          // Good guide on how to get element coordinates:
          // http://javascript.info/tutorial/coordinates
        }
      },
      id: '',
      minimumPrice: 0,
      reservePrice: 0,
      auctionInfo: {
        winner: {}
      },
      store: {},
      imagesList: [],
      importInfo: [ // 重要信息
        { key: 'transferRequest', name: '过户要求' },
        { key: 'newPlace', name: '迁往何处' },
        { key: 'buy', name: '买方承担' },
        { key: 'sell', name: '卖方承担' },
        { key: 'note', name: '评估简述' }
      ],
      basiceInfoData: {},
      basiceInfo: [ // 基本信息
        { key: 'car_model_name', name: '车辆信息' },
        { key: 'vin', name: '车辆VIN码' },
        { key: 'mileage', name: '表显里程' },
        { key: 'Engine_ExhaustForFloat', name: '排量（L）' },
        { key: 'emission_standard_name', name: '排放标准' },
        { key: 'production_date', name: '出厂日期' },
        { key: 'license_issued_on', name: '首次上牌' },
        { key: 'located_address', name: '车辆所在地' },
        { key: 'belonged_address', name: '车辆归属地' },
        { key: 'plate_number', name: '车牌' },
        { key: 'car_character_name', name: '车辆性质' },
        { key: 'usage_character_name', name: '使用性质' },
        { key: 'Perf_DriveType', name: '驱动形式' },
        { key: 'UnderPan_TransmissionType', name: '变速形式' },
        { key: 'color_name', name: '车身颜色' },
        { key: 'refitted', name: '是否改装' }
      ],
      procedureInfoData: {},
      procedureInfo: [ // 手续信息
        { key: 'purchaseTax', name: '购置税' },
        { key: 'drivingLicense', name: '行驶证' },
        { key: 'registration', name: '登记证' },
        { key: 'annualDue', name: '年检到期日' },
        { key: 'strongInsurance', name: '强险到期日' },
        { key: 'commercialInsurance', name: '商险到期日' },
        { key: 'carInvoice', name: '新车发票' },
        { key: 'carWarranty', name: '新车质保' },
        { key: 'key', name: '钥匙' },
        { key: 'maintenanceManual', name: '保养手册' },
        { key: 'instructions', name: '说明书' },
        { key: 'unHandleIllegal', name: '未处理违章' },
        { key: 'transfer_count', name: '过户次数' },
        { key: 'last_transfer_date', name: '最后过户日期' },
        { key: 'transferTickets', name: '过户票' },
        { key: 'proceduresSpend', name: '手续补办费用' }
      ],
      newPlaceList: { // 迁往何处
        '1': '本市',
        '2': '外迁',
        '3': '本市外迁均可'
      },
      purchaseTaxList: { // 购置税
        '1': '已征收',
        '2': '未征收'
      },
      proceduresSpendList: { // 手续补办费用
        '1': '买方承担',
        '2': '卖方承担',
        '3': '无'
      },
      frozenAmount: 0
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getData()
  },
  computed: {
    timeOut: {
      get() {
        return this.$store.state.timeOut
      },
      set(val) {
        this.$store.commit('UPDATE_TIMEOUT', val)
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOut)
    this.timeOut = null
  },
  methods: {
    goConditionReport() {
      const {
        is_reported: isQueryed,
        order_id: orderId
      } = this.basiceInfoData || {}
      const id = this.$route.params.id
      if (!isQueryed) {
        return
      }
      if (orderId) {
        return window.location.origin + '/api/v1/cbs/get_cbs_report_detail?order_id=' + orderId
      }
      return `/usedcar/inquiry/process/${id}`
    },
    clickSwiper(item) {
      this.$refs.previewer.show(item)
    },
    render(arr = []) {
      arr.map((v, i) => {
        let img = new window.Image()
        img.src = v.src
        // 如果图片被缓存，则直接返回缓存数据
        if (img.complete) {
          v.w = img.width
          v.h = img.height
          this.imgCount++
        } else {
          // 完全加载完毕的事件
          img.onload = () => {
            v.w = img.width
            v.h = img.height
            this.imgCount++
          }
        }
      })
      return arr
    },
    getData() {
      this.$rest.auction.getAuctionDetail(null, `${this.id}/detail`).then((res) => {
        if (res.code === 0) {
          let carInfo = res.data.auction_car
          this.minimumPrice = res.data.minimum_price
          this.reservePrice = res.data.reserve_price
          this.store = res.data.store
          this.store['contact_name'] = res.data.contact_name
          this.store['contact_number'] = res.data.contact_number
          this.imagesList = carInfo.images
          if (this.imagesList.length > 0) {
            this.imagesList.forEach((item, index) => {
              this.imagesList[index].src = item.image_url
            })
            this.imagesList = this.render(this.imagesList)
          }
          this.basiceInfoData = this.getBasiceInfoData(carInfo.car_info)
          this.procedureInfoData = this.getProcedureInfoData(carInfo.car_info.info.procedure)
          this.frozenAmount = res.data.auction_session.frozen_amount
        } else {
          this.showToast(res.message)
        }
      }).then(() => {
        this.getAuctionInfo()
      })
    },
    getAuctionInfo() {
      this.$rest.auction.getAuctionDetailStatus(null, `${this.id}/status`).then((res) => {
        if (res.code === 0) {
          let auction = this.auctionInfo = res.data
          clearInterval(this.timeOut)
          if (auction.next_auction_id && (auction.status_code === 'sold' || auction.status_code === 'unsold')) {
            this.timeOut = setTimeout(() => {
              this.id = auction.next_auction_id
              this.getData()
            }, 5000)
          }
          if (auction.status_code === 'pending' || auction.status_code === 'bidding') {
            let _this = this
            this.timeOut = setTimeout(() => {
              let curPath = _this.$route.path
              if (curPath.indexOf('/auction/info' > -1)) {
                _this.getAuctionInfo()
              } else {
                _this.timeOut = null
              }
            }, 900)
          }
        }
      })
    },
    getBasiceInfoData(data) {
      if (data) {
        let list = data.info.config[0].params
        data['mileage'] = (data.mileage / 10000).toFixed(2) + '万公里'
        data['Engine_ExhaustForFloat'] = this.getValue(list, 'Engine_ExhaustForFloat')
        data['located_address'] = `${data.located_province}${data.located_city}`
        data['belonged_address'] = `${data.belonged_province}${data.belonged_city}`
        data['Perf_DriveType'] = this.getValue(list, 'Perf_DriveType')
        data['UnderPan_TransmissionType'] = this.getValue(list, 'UnderPan_TransmissionType')
        data['refitted'] = data.is_refitted ? '是' : '否'
        if (data.is_color_changed) data['color_name'] = `${data.color_name}，已变更颜色`
        return data
      }
    },
    getValue(arr, key) {
      let item = arr.find(v => {
        return key === v.external_name
      })
      return item ? item.value : '--'
    },
    getProcedureInfoData(data) {
      if (data) {
        // 重要信息过滤
        data['transferRequest'] = `${data.transferRequest}天`
        data['newPlace'] = this.newPlaceList[data.newPlace]
        data['buy'] = this.getTransferFee(data.transferFee, data.freight, data.mentionFee, '1')
        data['sell'] = this.getTransferFee(data.transferFee, data.freight, data.mentionFee, '2')
        // 手续信息过滤
        data['purchaseTax'] = this.purchaseTaxList[data.purchaseTax]
        data['key'] = `${data.key} 把`
        data['commercialInsurance'] = data.commercialInsurance || '--'
        data['transfer_count'] = this.basiceInfoData['transfer_count']
        data['last_transfer_date'] = this.basiceInfoData['last_transfer_date'] || '--'
        data['proceduresSpend'] = this.proceduresSpendList[data.proceduresSpend]
        data['note'] = this.basiceInfoData.note
        return data
      }
    },
    getTransferFee(transferFee, freight, mentionFee, key) {
      let value = ''
      if (transferFee === key) value += '过户费、'
      if (freight === key) value += '运费、'
      if (mentionFee === key) value += '提档费、'
      return value ? value.slice(0, -1) : '无'
    }
  }
}

</script>
<style lang="less">
.auction_info {
  background-color: #fff;
}
</style>
